import { useApiInfo } from '../lib/api/queries';

/**
 * Small live indicator showing whether the API is reachable + what version
 * is deployed. Useful during dev for spotting when the backend has crashed
 * and during demos for confidence that the deployed bits match expectations.
 */
export function ApiStatus() {
  const { data, isError, isLoading } = useApiInfo();

  if (isLoading) {
    return <Pill colour="muted">API …</Pill>;
  }
  if (isError || !data) {
    return <Pill colour="danger" title="API unreachable">API ✗</Pill>;
  }
  return (
    <Pill colour="success" title={`${data.environment} · ${data.machineName}`}>
      API · v{data.version}
    </Pill>
  );
}

function Pill({
  colour,
  title,
  children,
}: {
  colour: 'success' | 'danger' | 'muted';
  title?: string;
  children: React.ReactNode;
}) {
  const cls =
    colour === 'success' ? 'bg-success-500/20 text-white'
    : colour === 'danger'  ? 'bg-danger-500/30 text-white'
    : 'bg-brand-700 text-brand-100';
  return (
    <span title={title} className={`text-xs font-medium px-2 py-1 rounded-full ${cls}`}>
      {children}
    </span>
  );
}
